import { legacyBreakpoints } from '@carvana/merch-tailwind/breakpoints';
import styled from 'styled-components';
import Loader from '@/vdp/Loader';

const LoaderWrapper = styled.div.attrs({
  className: 'flex justify-center'
})`
  height: ${props => props.heights.mobile}px;
  margin-top: ${props => props.topMargin}px;

  @media (min-width: ${legacyBreakpoints.m}px) {
    height: ${props =>
      props.heights.tablet ? props.heights.tablet : props.heights.mobile}px;
  }
  @media (min-width: ${legacyBreakpoints.l}px) {
    height: ${props =>
      props.heights.desktop ? props.heights.desktop : props.heights.mobile}px;
  }
`;

type LoaderConfig = {
  loaderTop?: boolean;
  loaderTopMargin?: number;
  skeletonHeight: {
    mobile: number;
    tablet?: number;
    desktop?: number;
  };
};

const SectionLoader = ({
  loaderTop,
  loaderTopMargin,
  skeletonHeight
}: LoaderConfig) => (
  <LoaderWrapper
    className={loaderTop ? 'items-start' : 'items-center'}
    heights={skeletonHeight}
    topMargin={loaderTopMargin}
  >
    <Loader large noMargin />
  </LoaderWrapper>
);

export default SectionLoader;
